module.exports = __webpack_public_path__ + "static/media/S12.f41df0a6.png";